import styled, { css } from 'styled-components';

type ContainerProps = {
  isRow?: boolean;
  isColumn?: boolean;
  isMobile?: boolean;
};

export const DateContainer = styled.div<ContainerProps>`
  ${({ isColumn }) => {
    if (isColumn) {
      return css`
        .datePicker {
          grid-template-columns: auto;
        }

        .datePicker:not(:first-child) {
          padding-top: 10px;
        }
      `;
    }

    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    `;
  }}
`;

export const Label = styled.div`
  font-size: 14px;
  line-height: 1.2;
  justify-content: center;
  display: inline-flex;
  align-items: center;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border: 1px solid;
  border-color: #e7e7e8;
  border-right: none;
  padding-inline-start: 0.75rem;
  padding-inline-end: 0.5rem;
  border-radius: 0.375rem 0 0 0.375rem;
`;
